import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { FiDisplayType } from '../../types/display-type';

@Component({
    selector: 'fi-items-list-display-type',
    template: `
        <button
            mat-icon-button
            class="insert-media-list-display-type-button"
            (click)="setInsertMediaDisplayType(displayType.Grid)"
            [ngClass]="{ BrandedColor: !isTableDisplayType }"
        >
            <span class="fas fa-th-large"></span>
        </button>
        <button
            mat-icon-button
            class="insert-media-list-display-type-button"
            (click)="setInsertMediaDisplayType(displayType.List)"
            [ngClass]="{ BrandedColor: isTableDisplayType }"
        >
            <span class="fas fa-list"></span>
        </button>
    `,
    styleUrls: ['./fi-items-list-display-type.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-items-list-display-type' },
    standalone: false,
})
export class FiItemsListDisplayTypeComponent implements OnInit {
    @Output() onDisplayTypeChange = new EventEmitter<number>();
    @Input() isTableDisplayType: boolean;
    displayType = FiDisplayType;

    constructor() {}

    ngOnInit(): void {}

    setInsertMediaDisplayType(newDisplayType: number) {
        this.onDisplayTypeChange.emit(newDisplayType);
    }
}
